import { translations } from "@emed/virtual-lab-ui-shared/content/translations";
import { EnvironmentProvider } from "@emed/virtual-lab-ui-shared/providers/EnvironmentProvider";
import { LanguageProvider, LanguageUtils } from "@emed/virtual-lab-ui-shared/providers/LanguageProvider";
import { LogProvider } from "@emed/virtual-lab-ui-shared/providers/LogProvider";
import { ModalProvider } from "@emed/virtual-lab-ui-shared/providers/ModalProvider";
import { Trans } from "@emed/virtual-lab-ui-shared/providers/TranslationProvider";
import { AWSConnectAgentGlobalProvider } from "./AWSConnectAgentGlobalProvider";
import { NavigatorProvider } from "@emed/virtual-lab-ui-shared/providers/NavigatorProvider";
import { ThemeProvider } from "@emed/virtual-lab-ui-shared/providers/ThemeProvider";

function GlobalProctorUIProviders(props: { children: any }) {
	return (
		<EnvironmentProvider>
			<LogProvider>
				<LanguageProvider language={LanguageUtils.getUserLanguage()}>
					<Trans.container resources={translations}>
						<ThemeProvider>
							<ModalProvider>
								<AWSConnectAgentGlobalProvider>
									<NavigatorProvider>{props.children}</NavigatorProvider>
								</AWSConnectAgentGlobalProvider>
							</ModalProvider>
						</ThemeProvider>
					</Trans.container>
				</LanguageProvider>
			</LogProvider>
		</EnvironmentProvider>
	);
}

export default GlobalProctorUIProviders;
